import {FC} from 'react';
import clsx from 'clsx';

import Icon, {Icons} from '../Icon';
import s from './styles.module.scss';

const NavLink: FC<any> = ({
  label,
  href,
  disabled,
  id,
  carretLeft,
  carretRight,
  icon,
  asChild,
  onClick,
}) => {
  const getBody = () => (
    <>
      {carretLeft && <Icon name={Icons.carretLeft} className={s['nav-link__arrow-left']} />}
      <Icon name={icon} className={s['nav-link__icon']} />
      <span className={s['nav-link__label']}>{label}</span>
      {carretRight && <Icon name={Icons.carretRight} className={s['nav-link__arrow-right']} />}
    </>
  );

  if (href) {
    return (
      <a
        id={id}
        className={clsx(s['nav-link'], {
          [s['nav-link__child']]: asChild,
          [s['nav-link__disabled']]: disabled,
        })}
        onClick={() => {
          document.dispatchEvent(new Event('click'));
        }}
        href={href}
      >
        {getBody()}
      </a>
    );
  }

  return (
    <div
      className={clsx(s['nav-link'], {
        [s['nav-link__child']]: asChild,
        [s['nav-link__disabled']]: disabled,
      })}
      onClick={onClick}
    >
      {getBody()}
    </div>
  );
};

export default NavLink;
